var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-link"},[_c('primary-nav-item',{attrs:{"name":"NOTIFICATIONS","icon":"alert","to":("/app/accounts/" + _vm.accountId + "/notifications"),"count":_vm.unreadCount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }